<template>
  <button
    type="button"
    class="tw-mx-2 tw-rounded-full tw-border-none tw-bg-secondary-100/0 tw-text-dorian-gray-500 tw-outline-none tw-ring-4 tw-ring-secondary-100/0 tw-transition-all hover:tw-cursor-pointer hover:tw-bg-secondary-100 hover:tw-text-secondary-500 hover:tw-ring-secondary-100 active:tw-bg-secondary-200 active:tw-ring-secondary-200 dark:hover:tw-bg-secondary-200 dark:hover:tw-ring-secondary-200 dark:active:tw-bg-secondary-100 dark:active:tw-ring-secondary-100"
    @click="emitClick"
  >
    <ClIconTablerTrash :width="'18'" :height="'18'" />
  </button>
</template>

<script lang="ts" setup>
import { ClIconTablerTrash } from "../icons";

const emit = defineEmits<{
  (event: "on-click"): void;
}>();

const emitClick = (): void => {
  emit("on-click");
};
</script>

<style scoped></style>
